import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-129ea23e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Go Home")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "your buildings", -1))
const _hoisted_6 = {
  key: 1,
  class: "buildings-container"
}
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-building" })
], -1))
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "create-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-square-plus" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txt" }, "Create a building", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "form-container"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Building name", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "desc" }, [
  /*#__PURE__*/_createTextVNode("Building description "),
  /*#__PURE__*/_createElementVNode("span", { class: "explain" }, "*explain the characteristics and features of your building")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "location" }, [
  /*#__PURE__*/_createTextVNode("Location "),
  /*#__PURE__*/_createElementVNode("span", { class: "explain" }, "*give the precise location of the building")
], -1))
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "back-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
    }, _hoisted_4),
    _hoisted_5,
    (_ctx.spin)
      ? (_openBlock(), _createBlock(_component_BasicSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.buildings.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildings, (building) => {
            return (_openBlock(), _createElementBlock("a", {
              href: 'building/' + building._id,
              class: "single-building",
              key: building._id,
              onClick: ($event: any) => (_ctx.topbarState.updateBuildingName(building))
            }, [
              _hoisted_8,
              _createElementVNode("h3", _hoisted_9, _toDisplayString(building.name), 1)
            ], 8, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "create-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm = !_ctx.showForm))
      }, _hoisted_13),
      (_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("form", {
              class: "building-form",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createBuilding && _ctx.createBuilding(...args)), ["prevent"]))
            }, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "name",
                class: "in name-in",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.name]
              ]),
              _hoisted_16,
              _withDirectives(_createElementVNode("textarea", {
                name: "desc",
                class: "in desc-in",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.description]
              ]),
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "location",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.location) = $event)),
                class: "loc-in in",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.location]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "submit-btn",
                disabled: _ctx.spin
              }, "create", 8, _hoisted_18)
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}